export default __webpack_public_path__ + "static/media/selected13.60a44375.png";